import React, { useMemo } from "react";
import { formatCash } from "../../utils/operatorConsoleHelpers";
import {
  formatTicketDate,
  getBetHouseName,
  getTicketProgress,
} from "../../utils/joinedBetsHelpers";

const JoinedBetListRow = ({ bet, selected, onSelect }) => {
  const fixtures = useMemo(
    () => (Array.isArray(bet?.fixtures) ? bet.fixtures : []),
    [bet?.fixtures]
  );
  const progress = useMemo(() => getTicketProgress(fixtures), [fixtures]);

  if (!bet?._id) return null;

  return (
    <button
      type="button"
      className={`jb-rail-row ${selected ? "jb-rail-row-active" : ""}`}
      onClick={() => onSelect(bet._id)}
    >
      <div className="jb-rail-row-top">
        <strong>{getBetHouseName(bet)}</strong>
      </div>
      <div className="jb-rail-row-meta">
        <span className="tabular-nums">
          {fixtures.length} leg{fixtures.length === 1 ? "" : "s"}
        </span>
        <span>·</span>
        <time>{formatTicketDate(bet.createdAt)}</time>
      </div>
      <div className="jb-rail-row-finance">
        <div>
          <em>Staked</em>
          <strong className="tabular-nums">
            {formatCash(bet.amountBet || 0, { compact: true })}
          </strong>
        </div>
        <div>
          <em>Potential</em>
          <strong className="tabular-nums jb-rail-potential">
            {formatCash(bet.potentialWinnings || 0, { compact: true })}
          </strong>
        </div>
      </div>
      <div className="jb-rail-row-progress">
        <div className="jb-progress-track">
          <span style={{ width: `${Math.round(progress.ratio * 100)}%` }} />
        </div>
        <span className="tabular-nums">
          {progress.finished}/{progress.total} FT
        </span>
      </div>
    </button>
  );
};

export default JoinedBetListRow;
